module.exports = __webpack_public_path__ + "static/media/sad2.9fa24da8.gif";